// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3dvbf","title":"ClientInsurance_title__3DiF0","itemText":"ClientInsurance_itemText__3mrBR"};